// extracted by mini-css-extract-plugin
module.exports = {"tags":"_383d9cc","tag":"_cd3df71","lightGrey":"_d5a4db8","purple":"_d5a5dce","blue":"_c708942","green":"_67324a9","grey":"_3a88278","yellow":"_b39b1c7","red":"_a2ac730"};